import type { AlertLevel } from '@/shared/generated'

import React from 'react'
import { useTranslation } from 'react-i18next'

import { Badge } from '@/shared/components/ui/badge'
import { formatNumber } from '@/shared/tools/locale'

import ListGroup, {
	ListGroupContent,
	ListGroupEnd,
	ListGroupInner,
	ListGroupItem,
} from '../ListGroup'

type AnchoringAlertsGroupProps = {
	count: number
	kind: AlertLevel
	alerts: { name: string; anchors: number; id: string }[]
	onFilterClick(ids: string[]): void
	onAnalyticsShowNotification?: (kind: AlertLevel) => void
}
export default function AnchoringAlertsGroup({
	kind,
	count,
	alerts,
	onFilterClick,
	onAnalyticsShowNotification,
}: AnchoringAlertsGroupProps) {
	const { t } = useTranslation()

	const handleShowButtonClick = (id: string) => {
		onAnalyticsShowNotification?.(kind)
		onFilterClick([id])
	}

	return (
		<ListGroup className='relative overflow-hidden rounded-lg border bg-secondary fade-in'>
			<ListGroupItem className='relative px-3 py-2'>
				<ListGroupInner>
					<ListGroupContent className='text-sm font-semibold'>
						{t('app.total_amount', { defaultValue: 'Total amount' })}
					</ListGroupContent>
					<ListGroupEnd>
						<Badge variant='destructive'>{`${formatNumber(count)}`}</Badge>
					</ListGroupEnd>
				</ListGroupInner>
			</ListGroupItem>
			{alerts?.map(({ name, anchors, id }) => (
				<ListGroupItem key={id} className='relative px-3 py-2 text-sm'>
					<ListGroupInner>
						<ListGroupContent>
							<span>{t(name, { defaultValue: name })}</span>
						</ListGroupContent>
						<ListGroupEnd>
							<Badge
								data-testid={`badge_${kind}_${id}`}
								variant='destructive'
								className='cursor-pointer hover:opacity-70'
								onClick={handleShowButtonClick.bind(null, id)}
							>
								{`${formatNumber(anchors)}`}
							</Badge>
						</ListGroupEnd>
					</ListGroupInner>
				</ListGroupItem>
			))}
		</ListGroup>
	)
}
